export enum EditableCardState {
    View = "View", // ReadOnly fields with Edit Pencil
    ViewDisabled = "ViewDisabled", // ReadOnly with disabled Edit Pencil Button
    ViewInvisible = "ViewInvisible", // ReadOnly without Edit Pencil
    Edit = "Edit", // Edit fields
    Save = "Save", // Loading and disabled Save button / Disabled Cancel button
    SaveDisabled = "SaveDisabled" // Diabled Save button
}
